import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import '../../css/Anamnese.css';
import '../../css/style.css';
import ImagensSilhuetas from '../../images/anamneseMulhersCorpos.png';
import { proximaEtapa, textoProximaEtapa } from '../../data/fluxoAvaliacao';

// Dados das perguntas
const PERGUNTAS = [
    { id: 0, texto: "1. Daqui a 3 meses, o que você mais quer como benefício do treino?", tipo: "checkbox" },
    { id: 1, texto: "2. Sente alguma dor no corpo NESSE MOMENTO? Se sim, em qual região?", tipo: "text", placeholder: "Não / Sim, na região..." },
    { id: 2, texto: "3. Nos últimos 30 dias, sentiu alguma dor ou desconforto? Se sim, onde?", tipo: "text", placeholder: "Não / Sim, na região..." },
    { id: 3, texto: "4. Você tem dificuldade em realizar estas atividades EM CASA ou no quintal?", tipo: "checkbox", temOutros: true },
    { id: 4, texto: "5. Você tem dificuldade em realizar estas atividades NA RUA (fora de casa)?", tipo: "checkbox" },
    { id: 5, texto: "6. Você tem conhecimento ou diagnóstico médico de alguma destas condições?", tipo: "checkbox", temOutros: true },
    { id: 6, texto: "7. Você sente fraqueza nas pernas quando vai caminhar ou subir escadas?", tipo: "radio" },
    { id: 7, texto: "8. Toma remédio todos os dias? Se sim, assinale o motivo abaixo:", tipo: "checkbox", temOutros: true },
    { id: 8, texto: "9. Alguma vez ao caminhar, você perdeu o equilíbrio e caiu?", tipo: "radio" },
    { id: 9, texto: "10. Já realizou alguma cirurgia? Se sim, assinale a região abaixo:", tipo: "checkbox", temOutros: true },
    { id: 10, texto: "11. O que te deixaria mais feliz conseguir fazer sem dor ou cansaço?", tipo: "checkbox", temOutros: true },
    { id: 11, texto: "12. O que mais te incomoda HOJE?", tipo: "checkbox", temOutros: true }
];

const OPCOES_RESPOSTAS = [
    { id: 0, opcoes: ["Não sentir dores no corpo", "Emagrecer", "Caminhar sem se sentir cansado(a)", "Fazer tarefas diárias sem cansaço", "Tomar menos remédios"] },
    { id: 1, opcoes: [] },
    { id: 2, opcoes: [] },
    { id: 3, opcoes: ["Nenhuma", "Caminhar", "Ficar em pé parado", "Agachar", "Levantar da cadeira/sofá/cama", "Me vestir", "Pentear o cabelo", "Limpar a casa"] },
    { id: 4, opcoes: ["Nenhuma", "Caminhar por mais de 10 min", "Caminhar por mais de 20 min", "Ficar em pé parado", "Desviar de obstáculos", "Agachar", "Subir degraus de ônibus", "Descer degraus de ônibus", "Levantar do banco do carro/ônibus", "Caminhar carregando peso"] },
    { id: 5, opcoes: ["Nenhuma", "Hipertensão arterial", "Alzheimer", "Parkinson", "Depressão", "Ansiedade", "Dislipidemia", "Colesterol elevado", "Triglicérides elevado", "Gordura no fígado", "Obesidade", "Diabetes tipo 1", "Diabetes tipo 2", "Doença coronariana", "Doença Renal", "Insuficiência cardíaca", "Câncer", "Neuropatias"] },
    { id: 6, opcoes: ["Sim", "Não"] },
    { id: 7, opcoes: ["Não tomo remédio", "Hipertensão arterial", "Alzheimer", "Parkinson", "Depressão", "Ansiedade", "Dislipidemia", "Colesterol elevado", "Triglicérides elevado", "Gordura no fígado", "Obesidade", "Diabetes tipo 1", "Diabetes tipo 2", "Doença coronariana", "Doença Renal", "Insuficiência cardíaca", "Câncer", "Neuropatias"] },
    { id: 8, opcoes: ["Sim", "Não"] },
    { id: 9, opcoes: ["Não realizei cirurgias", "Cabeça", "Pescoço", "Ombros", "Braço", "Punho", "Mão", "Quadril", "Pernas", "Tornozelo", "Pés"] },
    { id: 10, opcoes: ["Viajar", "Passear no shopping", "Dançar", "Brincar com os netos", "Caminhar ao ar livre", "Conhecer novas pessoas"] },
    { id: 11, opcoes: ["Dor no corpo", "Ficar sempre cansado(a)", "Não conseguir brincar com os netos", "Não conseguir dançar", "Não conseguir caminhar sem parar", "Tomar muitos remédios", "Não conseguir cuidar da casa", "Precisar de ajuda para coisas simples"] }
];

function AnamneseIdosos({ setPerfilAnamnese, setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {

    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 3;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        console.log(respostasSelecionadas);
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    // Modal para selecionar a anamnese
    const [isAnamneseTypeModal, setIsAnamneseTypeModal] = useState(false);
    const openAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(true);
    };
    const closeAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(false);
    };

    const [isChoosingAnamnese, setIsChoosingAnamnese] = useState(false);
    const handleChooseAnamnese = () => {
        setIsChoosingAnamnese(true);
    };

    // SALVAR E BUSCAR NO BD - LEVI
    const [respostasSelecionadas, setRespostasSelecionadas] = useState(
        PERGUNTAS.map(p => ({ id: p.id, valor: p.tipo === 'checkbox' ? [] : "" }))
    );

    const [observacoes, setObservacoes] = useState(evaluationData?.observacoesAnamnese || "");

    useEffect(() => {
        if (evaluationData?.anamnesis) {
            setRespostasSelecionadas(evaluationData.anamnesis);
        }
        if (evaluationData?.observacoesAnamnese !== undefined) {
            setObservacoes(evaluationData.observacoesAnamnese);
        }
    }, [evaluationData]);

    const [selectedAnamnese, setSelectedAnamnese] = useState("anamneseIdosos");
    // FIM

    const handleConfirmTroca = () => {
        // Atualiza o estado no componente pai
        setPerfilAnamnese(selectedAnamnese);
        closeAnamneseTypeModal();
    };

    const atualizarResposta = (perguntaId, novoValor, tipo) => {
        setRespostasSelecionadas(prev => prev.map(item => {
            if (item.id !== perguntaId) return item;

            let valorFinal;
            if (tipo === 'checkbox') {
                const listaAtual = Array.isArray(item.valor) ? item.valor : [];
                valorFinal = listaAtual.includes(novoValor)
                    ? listaAtual.filter(v => v !== novoValor)
                    : [...listaAtual, novoValor];
            } else {
                valorFinal = novoValor;
            }
            return { ...item, valor: valorFinal };
        }));
    };

    const renderPergunta = (id) => {
        const pergunta = PERGUNTAS.find(p => p.id === id);
        if (!pergunta) return null; // Segurança caso o ID não exista

        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const r = rObj ? rObj.valor : (pergunta.tipo === 'checkbox' ? [] : "");
        const opcoesDaPergunta = OPCOES_RESPOSTAS.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                
                {pergunta.imagem && (
                    <div className="question-image-container" style={{ textAlign: 'center', margin: '10px 0' }}>
                        <img src={pergunta.imagem} alt="Referência" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                    </div>
                )}

                <div className="answer-container">
                    {/* ... Seus inputs (text, checkbox, radio) continuam exatamente iguais ... */}
                    {pergunta.tipo === 'text' && (
                        <input
                            className="answer-text"
                            value={r}
                            placeholder={pergunta.placeholder}
                            onChange={e => atualizarResposta(pergunta.id, e.target.value, 'text')}
                        />
                    )}
                    {/* Mapeamento das opções e lógica de "Outros" seguem abaixo igual ao seu código original */}
                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={pergunta.tipo === 'checkbox' ? r?.includes(opcao) : r === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao, pergunta.tipo)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}
                    {/* ... (manter bloco do temOutros) ... */}
                </div>
            </div>
        );
    };

    // --- LÓGICA DE DIVISÃO EM COLUNAS ---

    // 1. Filtramos as perguntas da etapa atual
    const perguntasDaEtapa = PERGUNTAS.filter((_, idx) => {
        if (etapa === 1) return idx < 8;
        if (etapa === 2) return idx >= 8 && idx < 16;
        return idx >= 16;
    });

    // 2. Calculamos o ponto médio para dividir as colunas
    const meio = Math.ceil(perguntasDaEtapa.length / 2);
    const perguntasEsquerda = perguntasDaEtapa.slice(0, meio);
    const perguntasDireita = perguntasDaEtapa.slice(meio);

    // Navegação provisória
    // No perfil idoso a etapa seguinte é a Classificação Funcional, não o ParQ.
    const proxima = proximaEtapa(aluno?.profile, 'Anamnese');
    const irParaProximaEtapa = () => {
        if (proxima) setActiveTab(proxima.chave);
    };

    const handleAnamnesisRegister = async () => {
        const payload = {
            anamnesis: respostasSelecionadas,
            observacoes,
            evaluationId
        };

        const response = await api.post(`/api/student/${aluno.id}/evaluation/anamnesis`, payload, { withCredentials: true });
        if (response.status === 200) {
            // Se o backend retornou um novo ID (pois acabou de criar no banco), nós atualizamos a página pai!
            if (response.data.evaluationId && setEvaluationId) {
                setEvaluationId(response.data.evaluationId);
            }
            if (updateEvaluationData) {
                updateEvaluationData({ anamnesis: respostasSelecionadas, observacoesAnamnese: observacoes });
            }
            openNextModal();
        }
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[0, 1, 2].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[3, 4].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[5, 6].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[7, 8].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[11, 12, 13].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[14, 15, 16].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[17, 18].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                        </div>
                    </div>
                )}

                <Modal
                    isOpen={isAnamneseTypeModal}
                    onRequestClose={closeAnamneseTypeModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    {isChoosingAnamnese ? (
                        <>
                            <p className="anamnese-modal-type-p">Selecione o tipo de anamnese:</p>
                            <select 
                                className="select-anamnese"
                                value={selectedAnamnese}
                                onChange={(e) => setSelectedAnamnese(e.target.value)}
                            >
                                <option value="anamneseAdultos">Adultos</option>
                                <option value="anamneseEmagrecimento">Mulheres emagrecimento</option>
                                <option value="anamneseIdosos">Idosos</option>
                                <option value="anamneseGestantes">Gestantes</option>
                                <option value="anamnesePosParto">Pós Parto</option>
                                <option value="anamneseObesos">Obesos</option>
                                <option value="anamneseDiabetes">Diabetes</option>
                                <option value="anamneseHipertensao">Hipertensão</option>
                                <option value="anamneseDepressao">Depressao</option>
                            </select>
                            <div>
                                <button className="next-prev-button" onClick={handleConfirmTroca}>
                                    Confirmar Troca
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="anamnese-modal-type-p">
                                De acordo com o perfil do avaliado, recomenda-se<br />
                                anamnese para <span className="anamnese-modal-type-profile">Adultos</span>. Deseja
                                continuar <br /> ou escolher outra anamnese?
                            </p>
                            <div className="sub-pagination-buttons">
                                <button className="next-prev-button" type="button" onClick={closeAnamneseTypeModal}>
                                    Continuar
                                </button>
                                <button className="next-prev-button" type="button" onClick={handleChooseAnamnese}>
                                    Trocar Anamnese
                                </button>
                            </div>
                        </>
                    )}
                </Modal>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Anamnese finalizada!</p>
                    <p className="popupNext-h2">{textoProximaEtapa(proxima)}</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={irParaProximaEtapa}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                {etapa === totalEtapas && (
                    <div className="anamnese-observacoes">
                        <div className="standard-title">Observações</div>
                        <textarea
                            className="anamnese-observacoes-input"
                            placeholder="Escreva observações adicionais sobre o avaliado..."
                            value={observacoes}
                            onChange={(e) => setObservacoes(e.target.value)}
                        />
                    </div>
                )}

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 3 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAnamnesisRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container" >
                        <div className="info-button" onClick={openAnamneseTypeModal}>
                            Trocar Anamnese
                        </div>
                        <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">A anamnese é a primeira etapa de uma avaliação física e consiste em uma entrevista estruturada entre o profissional
                                    de Educação Física e o avaliado. Seu objetivo é coletar informações detalhadas sobre o histórico de saúde, estilo de vida, hábitos e
                                    objetivos do indivíduo, servindo como base para um planejamento seguro e personalizado do programa de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AnamneseIdosos;